import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import { Provider } from "react-redux";
import { combineReducers, createStore } from "redux";
import { UserReducers } from "reducer/UserReducers";
import { UtilityReducer } from "reducer/UtilityReducer";

const rootReducer = combineReducers({
  user: UserReducers,
  utility: UtilityReducer,
});

// TODO Deprecated Issue
export const store = createStore(rootReducer);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
